
import { configureStore } from "@reduxjs/toolkit";
import serviceReducer from "./slices/serviceSlice";
import membershipReducer from "./slices/kitchenMembershipSlice";
import userAuthTokenSlice from "./slices/userTokenSlice"

const store = configureStore({
  reducer: {
    service: serviceReducer,
    membership: membershipReducer,
    userAuth: userAuthTokenSlice,
  },
});

export default store;

